import { Flex, TextField } from "@radix-ui/themes";
import { Button } from "@src/ui-kit";
import { memo } from "react";

import { Icon } from "@components/Icon";

import type { TFunction } from "i18next";
import { ButtonWrapper, StyledInput } from "./styles";

interface MarketListFiltersProps {
  t: TFunction<"translation", undefined>;
  search: string;
  onSearchChange: (value: string) => void;
  showFavorites: boolean;
  onShowAll: () => void;
  onShowFavorites: () => void;
}

export const MarketListFilters = memo(
  ({ t, search, onSearchChange, showFavorites, onShowAll, onShowFavorites }: MarketListFiltersProps) => (
    <Flex gap="8px" justify="between" mb="8px">
      <Flex data-testid="market-select:search" flexGrow="1">
        <StyledInput
          placeholder={t("marketSelect.searchPlaceholder")}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          autoFocus={false}
        >
          <TextField.Slot>
            <Icon color="gray-11" icon="ri-search-line" size={12} />
          </TextField.Slot>
        </StyledInput>
      </Flex>
      <Flex gap="4px">
        <ButtonWrapper
          data-testid="market-select:filter:all"
          onClick={(e) => {
            e.stopPropagation();
            onShowAll();
          }}
          onTouchEnd={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onShowAll();
          }}
        >
          <Button variant={!showFavorites ? "outline" : "soft"}>{t("common.all")}</Button>
        </ButtonWrapper>
        <ButtonWrapper
          data-testid="market-select:filter:favorites"
          onClick={(e) => {
            e.stopPropagation();
            onShowFavorites();
          }}
          onTouchEnd={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onShowFavorites();
          }}
        >
          <Button variant={showFavorites ? "outline" : "soft"}>{t("common.favorites")}</Button>
        </ButtonWrapper>
      </Flex>
    </Flex>
  ),
);

MarketListFilters.displayName = "MarketListFilters";
